import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SignedInContextService} from "@app/@shells/signed-in-shell/signed-in-context.service";
import {CheckedComponentInternal} from "@app/campaigns/campaign/@common/campaign-drafting/checked-component-internal";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-campaign-billing-phone-number[campaignForm]',
  templateUrl: './campaign-billing-phone-number.component.html',
  styleUrls: ['./campaign-billing-phone-number.component.scss']
})
export class CampaignBillingPhoneNumberComponent implements OnInit, OnChanges {
  @Input() campaignForm!: FormGroup;
  checked: CheckedComponentInternal;

  constructor() {
    this.checked = new CheckedComponentInternal('billingPhone');
  }

  ngOnInit(): void {
    this.applyComponentLogic();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['campaignForm'] && this.campaignForm) {
      this.applyComponentLogic();
    }
  }

  checkboxClicked(): void {
    this.checked?.checkboxClicked();
  }

  private applyComponentLogic(): void {
    const billingPhone = this.campaignForm.get('billingPhone')?.value;
    this.checked.init(this.campaignForm);
    if (!billingPhone) {
      const phone = this.campaignForm.get('phone')?.value;
      console.log(phone);
      this.checked?.initChecked(phone);
    }
  }
}
